export default __webpack_public_path__ + "b5b7bdebff9886acfe07b077e9357d84.png";